import React, { useState, useRef, useEffect } from 'react'
import _ from 'lodash'
import {
  Modal,
  Button,
  Grid,
  BaseForm as Form,
  notice,
  Axios,
  Message,
} from 'component/base'
import { Confirm } from 'component/pieces'
import { getConfig } from 'config'

export const AnzenKanrishaModal = props => {
  const {
    isOpenModal,
    onClickCancel,
    kumiaiin_id,
    kumiaiin_tekiyo_kikan_id,
    setShowModal,
    onEdited,
    mode,
    anzenkanrishaId,
  } = props

  const { api_endpoint } = getConfig()

  const [anzenkanrishaData, setanzenkanrishaData] = useState({})
  const [fileIds, setFileIds] = useState([])
  const [confirmModel, setConfirmModel] = useState(null)
  const [showConfirmPatch, setShowConfirmPatch] = useState(false)
  const [showConfirmDelete, setShowConfirmDelete] = useState(false)

  const mapModel = inputs => inputs
  const formRef = useRef()  

  const BASE_PATH = `/api/staff/kumiaiin/kumiaiin/${kumiaiin_id}/kumiaiin_tekiyo_kikan/${kumiaiin_tekiyo_kikan_id}/anzen_kanrisha_sennin_todokede`

  useEffect(() => {
    if ( mode === 'edit' ) {
      callGetApi()
    } else if ( mode === 'create') {
      setanzenkanrishaData({
        is_kenshoku: false,
        is_enabled: true,
        is_enabled_kansho_mail: true,
      })
      setFileIds([])
    }
  }, [isOpenModal, anzenkanrishaId])

  const callGetApi = async () => {
    const { data, error } = await Axios.ajax.get(`${BASE_PATH}/${anzenkanrishaId}`)
    if (error) return
    setanzenkanrishaData(data)
  }

  const onValidSubmit = model => {
    const shokumei = model.shokumei_shokumu_naiyo ?? ''
    if (!model.is_kenshoku && shokumei.trim() !== '') {
      notice({
        title: 'Error',
        description: '兼職はありません',
        type: 'error',
      })
      return
    }
    setConfirmModel(model)
    setShowConfirmPatch(true)
  }

  const onConfirm = () => {
    setShowConfirmPatch(false)
    if (mode === 'create') {
      postAnzenKanrisha(confirmModel)
    } else {
      patchAnzenKanrisha(confirmModel)
    }
  }
  const onConfirmDelete = () => deleteApi(anzenkanrishaId)

  const postAnzenKanrisha = async model => {
    const { error } = await Axios.ajax.post(`${BASE_PATH}` ,
      {
        ...model,
        koshu_shuryo_date: model.koshu_shuryo_date || null,
        koshu_shuryo_no: model.koshu_shuryo_no || "",
        shokumei_shokumu_naiyo: model.shokumei_shokumu_naiyo || "",
      }
    )
    if (error) {
      notice({
        title: `Error ${error.status}`,
        description: error.statusText,
        type: 'error',
      })
      return
    }
    notice({
      title: 'Success',
      description: '処理が正常に終了しました',
      type: 'success',
    })
    setShowModal(false)
    onEdited()
  }

  const patchAnzenKanrisha = async model => {
    const { error } = await Axios.ajax.patch(`${BASE_PATH}/${anzenkanrishaId}` ,
      {
        ...model,
        koshu_shuryo_date: model.koshu_shuryo_date || null,
        koshu_shuryo_no: model.koshu_shuryo_no || "",
        shokumei_shokumu_naiyo: model.shokumei_shokumu_naiyo || "",
        r_anzen_kanrisha_sennin_todokede_id: anzenkanrishaData.r_anzen_kanrisha_sennin_todokede_id,
      }
    )
    if (error) {
      notice({
        title: `Error ${error.status}`,
        description: error.statusText,
        type: 'error',
      })
      return
    }
    notice({
      title: 'Success',
      description: '処理が正常に終了しました',
      type: 'success',
    })
    setShowModal(false)
    onEdited()
  }

  const deleteApi = async anzenkanrishaId => {
    const { error } = await Axios.ajax.delete(
      `${BASE_PATH}/${anzenkanrishaId}`
    )
    if (error) {
      notice({
        title: `Error ${error.status}`,
        description: error.statusText,
        type: 'error',
      })
      return
    }
    notice({
      title: 'Success',
      description: '処理が正常に終了しました',
      type: 'success',
    })
    setShowModal(false)
    onEdited()
  }

  const onDeleteFile = id => {
    setFileIds(_.difference(fileIds, [id]))
  }
  

  return (
    <>
      <Modal
        closeOnEscape={true}
        closeOnDimmerClick={true}
        dimmer='inverted'
        onClose={onClickCancel}
        open={isOpenModal}
      >
        <Modal.Header>安全管理者選任届出</Modal.Header>

        <Modal.Content>
          <Form
            id='formmodal'
            mapping={mapModel}
            onValidSubmit={onValidSubmit}
            ref={formRef}
          >
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <Form.Textbox.Standard
                    name='name'
                    label='氏名'
                    required
                    value={anzenkanrishaData.name}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Form.Textbox.YMD
                    name='birthdate'
                    label='生年月日'
                    required
                    value={anzenkanrishaData.birthdate}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Form.Textbox.YMD
                    name='sennin_date'
                    label='選任年月日'
                    required
                    value={anzenkanrishaData.sennin_date}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Form.Textbox.Standard
                    name='toroku_koshu_kikan_name'
                    label='登録講習機関名'
                    required
                    value={anzenkanrishaData.toroku_koshu_kikan_name}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Form.Textbox.YMD
                    name='koshu_shuryo_date'
                    label='講習修了年月日'
                    value={anzenkanrishaData.koshu_shuryo_date}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Form.Textbox.Standard
                    name='koshu_shuryo_no'
                    label='講習修了番号'
                    value={anzenkanrishaData.koshu_shuryo_no}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Form.Checkbox.Buttony
                    name='is_kenshoku'
                    label='兼職の有無'
                    checked={anzenkanrishaData.is_kenshoku}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Form.Textbox.Standard
                    name='shokumei_shokumu_naiyo'
                    label='職名・職務内容'
                    value={anzenkanrishaData.shokumei_shokumu_naiyo}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Form.Checkbox.Buttony
                    name='is_enabled'
                    label='安全管理者選任届出有効/無効選択'
                    checked={anzenkanrishaData.is_enabled}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Form.Checkbox.Buttony
                    name='is_enabled_kansho_mail'
                    label='勧奨メール有効/無効選択'
                    checked={anzenkanrishaData.is_enabled_kansho_mail}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content='登録'
            icon='checkmark'
            form='formmodal'
            labelPosition='right'
            primary
          />
          <Button
            content='削除'
            secondary
            disabled={mode === 'create'}
            onClick={() => setShowConfirmDelete(true)}
          />          
          <Button onClick={onClickCancel} content='閉じる' />
        </Modal.Actions>
      </Modal>
      <Confirm
        open={showConfirmPatch}
        cancelButton='キャンセル'
        confirmButton='実行'
        header='確認'
        content={
          <Message
            info
            icon='info circle'
            content={mode === 'create' ? '新規登録します。よろしいですか？' : '変更を反映します。よろしいですか？'}
          />
        }
        onCancel={() => setShowConfirmPatch(false)}
        onConfirm={onConfirm}
      />
      <Confirm
        open={showConfirmDelete}
        cancelButton='キャンセル'
        confirmButton='実行'
        header='確認'
        content={
          <Message
            info
            icon='info circle'
            content='選択したデータを削除します。よろしいですか？'
          />
        }
        onCancel={() => setShowConfirmDelete(false)}
        onConfirm={onConfirmDelete}
      />      
    </>      
  )
}

AnzenKanrishaModal.defaultProps = {
  mode: 'create',
  anzenkanrishaId: null,
  onEdited: () => { },
}